<template>
  <div>
    <div style='min-height:400px' ref='leadtimeboxplot'></div>
    <lead-time-delivery-table
      v-if="data"
      :data="data"
    ></lead-time-delivery-table>
  </div>
</template>

<script>
import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'

import material from '@amcharts/amcharts4/themes/material.js'
import animated from '@amcharts/amcharts4/themes/animated.js'

import leadTimeDeliveryTable from './leadTimeDeliveryTable'

am4core.useTheme(animated)
am4core.useTheme(material)

export default {
mounted () {
  this.createChart()
},
data () {
  return {
    chart: null,
    data: null
  }
},
props: ['filterUrl'],
components : {
  leadTimeDeliveryTable
},
watch: {
  filterUrl(){
    this.getData()
  }
},
methods: {
  getData(){
    let length  = this.chart.data.length

    this.$http.get('/api/h1/delivery-lead-time?' + this.filterUrl)
    .then((resp)=>{
      let data = resp.data.data;

      let keys = Object.keys(data[0])
      for (var i = 0; i < data.length; i++) {
        for (var j = 0; j < keys.length; j++) {
          if (keys[j] === 'hari' || keys[j] === 'total') continue
          let chartValue = Math.round(data[i][keys[j]] / 24 * 100) / 100
          var quotient = Math.floor(data[i][keys[j]] / 24)
          var remainder = data[i][keys[j]] % 24

          data[i][keys[j]] = chartValue
          data[i][keys[j] + 'string'] = quotient + ' Day and ' + remainder + ' Hr'
        }
      }
      data = data.reverse()
      this.data = data;
      this.chart.addData(data , length)
    })
    .catch((err)=>{
      console.log(err);
    })
  },
  createChart () {
    this.chart = am4core.create(this.$refs.leadtimeboxplot, am4charts.XYChart)
    this.chart.paddingRight = 20

    // this.chart.dateFormatter.inputDateFormat = 'yyyy-MM-dd'

    let categoryAxis = this.chart.yAxes.push(new am4charts.CategoryAxis())
    categoryAxis.dataFields.category = 'hari'
    categoryAxis.renderer.minGridDistance = 40
    categoryAxis.renderer.grid.template.location = 0

    let valueAxis = this.chart.xAxes.push(new am4charts.ValueAxis())
    valueAxis.tooltip.disabled = true
    valueAxis.min = 0;
    valueAxis.title.text = 'Time By Days'

    let series = this.chart.series.push(new am4charts.CandlestickSeries())
    series.dataFields.categoryY = 'hari'
    series.dataFields.valueX = 'average'
    series.dataFields.openValueX = 'average'
    series.dataFields.lowValueX = 'minimum'
    series.dataFields.highValueX = 'maximum'
    series.simplifiedProcessing = true
    series.tooltipText = 'Min: {minimumstring}\nMax: {maximumstring}\nAvg: {averagestring}'
    series.tooltip.fontWeight = 'bold'
    series.riseFromOpenState = undefined
    series.dropFromOpenState = undefined
    series.strokeWidth = 2.5

    this.chart.cursor = new am4charts.XYCursor()

    let topSeries = this.chart.series.push(new am4charts.StepLineSeries())
    topSeries.noRisers = true
    topSeries.startLocation = 0.2
    topSeries.endLocation = 0.8
    topSeries.dataFields.valueX = 'maximum'
    topSeries.dataFields.categoryY = 'hari'
    topSeries.stroke = this.chart.colors.getIndex(0)
    topSeries.strokeWidth = 3

    let bottomSeries = this.chart.series.push(new am4charts.StepLineSeries())
    bottomSeries.noRisers = true
    bottomSeries.startLocation = 0.2
    bottomSeries.endLocation = 0.8
    bottomSeries.dataFields.valueX = 'minimum'
    bottomSeries.dataFields.categoryY = 'hari'
    bottomSeries.stroke = this.chart.colors.getIndex(0)
    bottomSeries.strokeWidth = 3

    this.chart.scrollbarX = new am4core.Scrollbar()
    // this.this.chart.data = this.data
  },
}
}
</script>
